import log from 'salvo-lite/log'

class Filter {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._filters = elem.querySelectorAll('.boost-pfs-filter-option-item')
        this._refined = document.querySelectorAll('.boost-pfs-filter-refine-by-items .refine-by-value')
        this._currency = document.querySelector('select[name="currency').value
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._filters.forEach(filter => {
            const filterName = filter.textContent
            if (filterName.includes('**')) {
                const fields = filterName.split('**')
                for (var i = 0; i < fields.length; i++) {
                    switch (this._currency) {
                    case 'GBP':
                    case 'AUD':
                        if (fields[i].toLowerCase().includes('uk')) {
                            filter.querySelector('.boost-pfs-filter-option-value').textContent = fields[i].split('-')[1]
                        }
                        break
                    case 'USD':
                    case 'CAD':
                        if (fields[i].toLowerCase().includes('us')) {
                            filter.querySelector('.boost-pfs-filter-option-value').textContent = fields[i].split('-')[1]
                        }
                        break
                    case 'EUR':
                        if (fields[i].toLowerCase().includes('eu')) {
                            filter.querySelector('.boost-pfs-filter-option-value').textContent = fields[i].split('-')[1]
                        }
                        break
                    }
                }
            }
        })
        this._refined.forEach(refine => {
            if (refine.textContent.includes('**')) {
                const fields = refine.textContent.split('**')
                for (var i = 0; i < fields.length; i++) {
                    switch (this._currency) {
                    case 'GBP':
                    case 'AUD':
                        if (fields[i].toLowerCase().includes('uk')) {
                            refine.textContent = fields[i].split('-')[1]
                        }
                        break
                    case 'USD':
                    case 'CAD':
                        if (fields[i].toLowerCase().includes('us')) {
                            refine.textContent = fields[i].split('-')[1]
                        }
                        break
                    case 'EUR':
                        if (fields[i].toLowerCase().includes('eu')) {
                            refine.textContent = fields[i].split('-')[1]
                        }
                        break
                    }
                }
            }
        })
    }
}

export default Filter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Filter.js